import React, { forwardRef, InputHTMLAttributes } from 'react';
import cn from 'classnames';

export interface ToggleProps extends InputHTMLAttributes<HTMLInputElement> {
    id: string;
    /**
     * Text shown on Left Label
     */
    leftLabel?: string;
    /**
     * Text shown on Right Label
     */
    rightLabel?: string;
}

/**
 * Representation of toggle elements
 */
export const Toggle = forwardRef<HTMLInputElement, ToggleProps>(
    (props, ref) => {
        const {
            id,
            leftLabel,
            rightLabel,
            disabled,
            className,
            style,
            ...rest
        } = props;
        const classes = cn(
            'a-toggle',
            {
                '-disabled': disabled,
            },
            className,
        );

        return (
            <div className={classes} style={style}>
                {leftLabel && (
                    <label className="a-toggle__label -left" htmlFor={id}>
                        {leftLabel}
                    </label>
                )}
                <input
                    type="checkbox"
                    ref={ref}
                    id={id}
                    name={id}
                    disabled={disabled}
                    {...rest}
                />
                <label className="a-toggle__box" htmlFor={id} />
                {rightLabel && (
                    <label className="a-toggle__label -right" htmlFor={id}>
                        {rightLabel}
                    </label>
                )}
            </div>
        );
    },
);
Toggle.displayName = 'Toggle';
